import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataTablesResponse } from '../models/datatables';
import { UeckoConfigCollectionAvailableDTO, UeckoConfigCollectionDTO, UeckoConfigCollectionTranslationDTO } from '../models/config-collection-dto';



@Injectable({
    providedIn: 'root'
})

export class ConfigCollectionService {

    private pathAPI = environment.urlAPI;
    private controller = "UeckoConfigCollection/";



    constructor(private http: HttpClient) { }


    public get(id: string): Observable<UeckoConfigCollectionDTO> {
        return this.http.get<UeckoConfigCollectionDTO>(this.pathAPI + this.controller + id);
    }

    public post(data: FormData): Observable<any> {
        return this.http.post<any>(this.pathAPI + this.controller, data);
    }

    public put(id: string, data: FormData): Observable<any> {
        return this.http.put<any>(this.pathAPI + this.controller + id, data);
    }

    public changeStatus(id: string, idStatus: number): Observable<any> {
        return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
    }

    public getDataTable(data: any): Observable<DataTablesResponse> {
        return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/', data);
    }

    public GetTranslationsForConfigCollection(id: string): Observable<UeckoConfigCollectionTranslationDTO[]> {
        return this.http.get<UeckoConfigCollectionTranslationDTO[]>(this.pathAPI + this.controller + 'GetTranslationsForConfigCollection/' + id);
    }

    public getAvailableConfigCollections(idWith): Observable<UeckoConfigCollectionAvailableDTO[]> {
        return this.http.get<UeckoConfigCollectionAvailableDTO[]>(this.pathAPI + this.controller + "GetAvailableConfigCollections/" + idWith);
    }

    getCollectionsExcel(): Observable<Blob> {
        let requestOptions: Object = {
            responseType: 'blob'
        }
        let endpoint = this.pathAPI + this.controller + 'GetCollectionsExcel';
        return this.http.get<Blob>(endpoint, requestOptions);
    }

    public reloadAllCaches(): Observable<any> {
        return this.http.post<any>(this.pathAPI + this.controller + 'ReloadAllCaches', null);
    }
}